<template>
  <div>
    <span v-if="title" class="rf-text-input--title">
      <slot v-if="slots['title']" name="title"></slot>
      <template v-else> {{ title }} </template>
    </span>
    <component
      :is="autocomplete ? 'v-autocomplete' : 'v-select'"
      v-bind="mergedAttrs"
      persistentPlaceholder
      menuIcon="mdi:mdi-chevron-down"
    >
      <template v-for="(_, name) in slots" #[name]="{ item, props, index }">
        <slot :name="name" :item="item" :props="props" :index="index" />
      </template>
    </component>
  </div>
</template>

<script setup>
import { computed, inject, useAttrs, useSlots } from "vue";
import { OVERLAY_Z_INDEX_KEY, OVERLAY_Z_INDEX_STEP } from "@/utils/composables/useOverlayZIndex";

defineOptions({ inheritAttrs: false });

const slots = useSlots();
const attrs = useAttrs();

defineProps({
  title: { type: String, default: "" },
  autocomplete: { type: Boolean, default: false },
});

const parentZIndex = inject(OVERLAY_Z_INDEX_KEY, null);

const mergedAttrs = computed(() => {
  if (!parentZIndex?.value) return attrs;
  return {
    ...attrs,
    menuProps: { ...attrs.menuProps, zIndex: parentZIndex.value + OVERLAY_Z_INDEX_STEP },
  };
});
</script>

<style lang="scss" scoped>
:deep(.v-input__details) {
  padding: 0 0.125rem !important;
}
:deep(
  .v-input:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset
) {
  border-color: rgba(158, 158, 158, 0.47) !important;
}

.rf-text-input--title {
  padding: 0 0.125rem;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0em;
  color: #383938;
}
</style>
